// Core modules
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
// Modules
import { HeaderModule } from 'components/header/header.module';

import { ProfessionalRouting } from './professional.route';
// Services
import { StripeService } from 'services/payment/stripe.service';
// Components
import { ProfessionalComponent } from './professional.component';

import { CertemyCommonModule } from 'common/certemy-common.module';
import { PageHeaderModule } from 'pages/professional/page-header/page-header.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CertificatesService } from 'services/professional/certificates/certificates.service';
import { NotificationsService } from 'services/notifications/notifications.service';
import { AuditService } from 'features/audit/audit.service';
import { CanDeactivateProfessionalService } from 'pages/professional/professional.can-deactivate';

@NgModule({
  declarations: [ProfessionalComponent],
  providers: [
    AuditService,
    StripeService,
    CanDeactivateProfessionalService,
    CertificatesService,
    NotificationsService,
  ],
  imports: [CertemyCommonModule, HeaderModule, RouterModule.forChild(ProfessionalRouting), PageHeaderModule, NgbModule],
})
export class ProfessionalModule {}
